export default {
  "config": {
    "trial": "tones-5",
    "id": "summary",
    "type": "design",
    "title": "An Overview of the TONES 5 Clinical Trial for Safety and Maintenance of Efficacy of Solriamfetol in the Treatment of EDS in Adults with Narcolepsy or OSA<sup>14</sup>",
    "footnotes": [],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-5",
    "id": "summary",
    "data-type": "design",
    "title": "An Overview of the TONES 5 Clinical Trial for Safety and Maintenance of Efficacy of Solriamfetol in the Treatment of EDS in Adults with Narcolepsy or OSA<sup>14</sup>"
  }
};